import React, { useCallback, useEffect, useRef, useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { Eyebrow } from "./Eyebrow";
import { ServiceCard } from "./ServiceCard";
import { practiceAreas } from "../data/practiceAreas";
export function ServicesCarousel() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);
  const update = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    setAtStart(el.scrollLeft <= 4);
    setAtEnd(el.scrollLeft + el.clientWidth >= el.scrollWidth - 4);
  }, []);
  useEffect(() => {
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, [update]);
  const scroll = (dir: 1 | -1) => {
    trackRef.current?.scrollBy({
      left: dir * 354,
      behavior: "smooth"
    });
  };
  const arrowBtn = "flex h-11 w-11 items-center justify-center rounded-full transition-colors duration-150 disabled:cursor-not-allowed";
  return <section id="expertise" className="w-full bg-white pb-[140px] pt-10" data-id="element-306" data-mp="1vwps3lvfmz7j">
      <div data-reveal className="mx-auto flex max-w-page flex-wrap items-end justify-between gap-8 px-6 lg:px-0" data-id="element-307" data-mp="20xx09m1hm0eq">
        <div data-id="element-308" data-mp="25unhwdsxx429">
          <Eyebrow data-id="element-309" data-mp="2angkav0xs0b6">Our expertise</Eyebrow>
          <h2 className="mt-6 text-[48px] font-semibold leading-[0.98] tracking-[-0.045em] text-ink lg:text-[80px]" data-id="element-310" data-mp="2aoi4bozxjx51">
            Focused expertise
            <br data-id="element-311" data-mp="2fow28e7thqpc" />
            <span className="text-stone" data-id="element-312" data-mp="2jnv75ytjtngs">for every matter</span>
          </h2>
        </div>
        <div className="flex flex-col items-end gap-6" data-id="element-313" data-mp="2on81f4mr1wte">
          <p className="max-w-[300px] text-right text-[15px] leading-[1.6] text-stone" data-id="element-314" data-mp="2onradvuf9ava">
            From commercial decisions to complex disputes — one team, clear advice.
          </p>
          <div className="flex gap-2" data-id="element-315" data-mp="uai92rc14vo4">
            <button type="button" onClick={() => scroll(-1)} disabled={atStart} aria-label="Previous services" className={`${arrowBtn} border border-line text-ink hover:border-ink disabled:text-ink/30 disabled:hover:border-line`} data-id="element-316" data-mp="ubjnn5s980al">
              <ChevronLeftIcon className="h-5 w-5" strokeWidth={1.75} data-id="element-317" data-mp="115i5g0e4nopk" />
            </button>
            <button type="button" onClick={() => scroll(1)} disabled={atEnd} aria-label="Next services" className={`${arrowBtn} bg-ink text-white hover:bg-accent hover:text-ink disabled:bg-ink/20 disabled:hover:text-white`} data-id="element-318" data-mp="w6oq02fa5nmr">
              <ChevronRightIcon className="h-5 w-5" strokeWidth={1.75} data-id="element-319" data-mp="1jvzwm0jbac8t" />
            </button>
          </div>
        </div>
      </div>

      <div ref={trackRef} data-reveal data-reveal-delay="1" onScroll={update} className="no-scrollbar mt-16 flex snap-x snap-mandatory scroll-px-6 gap-6 overflow-x-auto px-6 lg:scroll-px-[max(80px,calc((100vw-1280px)/2))] lg:px-[max(80px,calc((100vw-1280px)/2))]" data-id="element-320" data-mp="1ey7tead7v3pb">
        {practiceAreas.map(area => <ServiceCard key={area.title} area={area} data-id="element-321" data-mp="2cir6l3jjkgkf" />)}
      </div>
    </section>;
}